module.exports = __webpack_public_path__ + "img/zdjt.c1fdd462.png";